<div class="m-content">
  <div class="row">
    <div class="col-lg-12">
      <div class="m-portlet" style="min-height:450px">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon">
                <i class="flaticon-map-location"></i>
              </span>
              <h3 class="m-portlet__head-text">
                Refer & Earn
              </h3>

            </div>
          </div>
        </div>
        <div class="m-portlet__body">

          <div class="row">
            <div class="col-md-12" style="text-align:center">
              <div class="row">
                <div class="col-md-8" style="text-align:center">

                  <h1 style="font-size: 20px;">YOUR REFERRAL CODE </h1>
                  <br>
                  <span
                    style="background-color: rgb(203, 233, 180);padding:15px 70px 15px 70px">{{referralList['code']}}</span>
                  <br>
                  <br>
                  <button class="btn m-btn--pill btn-sm btn-success"
                    (click)="copyMessage(referralList['referralMessage'])" value="click to copy"
                    style="text-align:right">
                    Refer And Earn
                  </button>
                </div>
                <div class="col-md-4">
                  <h1 style="font-size:20px;font-weight:800;">Available Credits</h1>
                  <h1 style="font-size:26px;margin-right:50px;">{{creditList['credits']}}</h1>
                </div>

              </div>

            </div>

            <!-- <div class="col-md-6">
              <h1 style="font-size:20px;font-weight:800;">Available Credits</h1>
              <h1 style="font-size:26px;margin-right:50px;">{{creditList['credits']}}</h1>
            </div> -->
          </div>
          <h1 style="font-size:20px;margin-top: 40px;">History</h1>
          <br>
          <p-dataTable [value]="history" [rows]="20" [paginator]="true" [pageLinks]="3"
            [rowsPerPageOptions]="[20,30,40]">

            <p-column field="description" header="Description	" [sortable]="true">

            </p-column>
            <p-column field="createdAt" header="Created Date" [sortable]="true">
              <ng-template let-row="rowData" pTemplate="body">
                {{row.createdAt | date:'dd/MM/yyyy'}}
              </ng-template>
            </p-column>
            <p-column field="creditStatus" header="Credit Status" [sortable]="true">

            </p-column>
            <p-column field="credit" header="Credit" [sortable]="true">

            </p-column>



          </p-dataTable>



        </div>

      </div>
    </div>
  </div>


</div>


// WEBPACK FOOTER //
// ./src/app/core/pages/refer-earn/refer-earn.component.html